import React, { ComponentPropsWithoutRef, PropsWithChildren } from "react";
import "./OnboardingContainer.scss";

export default function OnboardingContainer({
  children,
  className,
  ...props
}: PropsWithChildren<ComponentPropsWithoutRef<"div">>) {
  return (
    <div className={`onboarding-container ${className}`} {...props}>
      {children}
    </div>
  );
}
